module.exports = __webpack_public_path__ + "images/category_lp/watch/rolex_samples/pattern_d4/cv_3_sp_e811030b2e75df94c4614d30e99c8027.jpg";